import React from 'react';
import { Link } from 'react-router-dom';
import styles from './MountainCard.module.css';
import { buildStorageUrl } from '../config/firebaseStorage';

const getImageLikeCount = (image) => (image && typeof image === 'object' ? image.likes || 0 : 0);

const sortImagesByLikes = (images) => {
  if (!Array.isArray(images) || images.length <= 1) return images;
  return [...images].sort((a, b) => getImageLikeCount(b) - getImageLikeCount(a));
};

function MountainCard({ mountain }) {
  const sortedImages = sortImagesByLikes(mountain.images);
  const firstImage = (sortedImages && sortedImages.length > 0) ? sortedImages[0] : null;
  const imageUrlRaw = firstImage
    ? (typeof firstImage === 'string' ? firstImage : firstImage.url)
    : null;

  const imageUrl = imageUrlRaw || buildStorageUrl('other/placeholderM.jpg');

  return (
    <Link to={`/mountains/${mountain.id}`} className={styles.mountainCard} aria-label={mountain.name}>
      <div className={styles.imageWrap}>
        <img src={imageUrl} alt="" className={styles.cardImage} />
        <div className={styles.overlay}>
          <div className={styles.height}>{mountain.height} m</div>
          <h2 className={styles.title}>{mountain.name}</h2>
        </div>
      </div>
    </Link>
  );
}

export default MountainCard;
